import { t } from 'i18next'
import { v4 as uuid } from 'uuid'
import React from 'react'
import {
  BookingCalendarInterface,
  BookingFormQuestion,
  FormQuestionAnswer,
} from 'common/types/entities/BookingCalendarInterface'
// import Checkbox from 'client/components/core/Sidebar/components/Settings/components/Checkbox'
import Input from 'client/components/core/Sidebar/components/Settings/components/Input/Input'
import Button from 'client/components/core/Sidebar/components/Settings/components/button'
import GroupTitle from 'client/components/core/Sidebar/components/Settings/styleComponents/GroupTitle'
import TextFontSize from 'client/components/core/Sidebar/components/Settings/styles/TextFontSize'
import TextLineHeight from 'client/components/core/Sidebar/components/Settings/styles/TextLineHeight'
import { useUpdateProp } from '../../hooks/useUpdateProps'

interface CustomQuestionsSettingsProps {
  entity: BookingCalendarInterface
}

export const CustomQuestionsSettings = ({
  entity,
}: CustomQuestionsSettingsProps) => {
  const updateProp = useUpdateProp(entity)

  const handleAddQuestion = () => {
    updateProp('questions')(
      entity.questions?.concat({
        id: uuid(),
        title: t(
          'entity_settings.booking_calendar.custom_question_default_label',
        ),
        placeholder: t(
          'entity_settings.booking_calendar.custom_question_default_placeholder',
        ),
        isRequired: false,
        answers: [
          {
            id: uuid(),
            title: t(
              'entity_settings.booking_calendar.custom_question_default_label',
            ),
            isOpen: true,
          },
        ],
      }),
    )
  }

  const handleUpdateQuestion = (
    id: string,
    questionUpdate: Partial<BookingFormQuestion>,
    answerUpdate?: Partial<FormQuestionAnswer>,
  ) => {
    updateProp('questions')(
      entity.questions?.map(question =>
        question.id === id
          ? {
              ...question,
              ...questionUpdate,
              answers: answerUpdate
                ? [{ ...question.answers[0], ...answerUpdate }]
                : question.answers,
            }
          : question,
      ),
    )
  }

  const handleRemoveQuestion = (id: string) => {
    updateProp('questions')(
      entity.questions?.filter(({ id: questionId }) => questionId !== id),
    )
  }

  return (
    <React.Fragment>
      <GroupTitle>entity_settings.booking_calendar.questions</GroupTitle>
      {entity.questions?.map(({ id, title, placeholder, isRequired }, index) => (
        <React.Fragment key={id}>
          <Input
            isResetIconVisible
            onReset={() => handleRemoveQuestion(id)}
            update={title => handleUpdateQuestion(id, { title }, { title })}
            label={`${t('entity_settings.booking_calendar.question')} ${index + 1}`}
            placeholder={t(
              'entity_settings.booking_calendar.custom_question_default_label',
            )}
            value={title}
          />
          <Input
            update={placeholder => handleUpdateQuestion(id, { placeholder })}
            label={t('entity_settings.textarea.placeholder.label')}
            placeholder={t(
              'entity_settings.booking_calendar.custom_question_default_placeholder',
            )}
            value={placeholder}
          />
          {/*<Checkbox*/}
          {/*  labelText="entity_settings.booking_calendar.mandatory"*/}
          {/*  value={isRequired}*/}
          {/*  update={isRequired => handleUpdateQuestion(id, { isRequired })}*/}
          {/*/>*/}
        </React.Fragment>
      ))}
      <Button onClick={handleAddQuestion}>
        {t('entity_settings.booking_calendar.add_a_question')}
      </Button>

      <GroupTitle>typography</GroupTitle>
      <TextFontSize
        update={updateProp('fieldFontSize')}
        mobileUpdate={updateProp('mobileFieldFontSize')}
        fontSize={entity.fieldFontSize}
        mobileFontSize={entity.mobileFieldFontSize}
        removeEntityStyle={updateProp('fieldFontSize')}
        removeEntityMobileStyle={updateProp('mobileFieldFontSize')}
      />
      <TextLineHeight
        fontSize={entity.fieldFontSize}
        mobileFontSize={entity.mobileFieldFontSize}
        update={updateProp('fieldLineHeight')}
        mobileUpdate={updateProp('mobileFieldLineHeight')}
        lineHeight={entity.fieldLineHeight}
        mobileLineHeight={entity.mobileFieldLineHeight}
        removeEntityStyle={updateProp('fieldLineHeight')}
        removeEntityMobileStyle={updateProp('mobileFieldLineHeight')}
      />
    </React.Fragment>
  )
}
